import React from 'react';
import Lottie from 'react-lottie';
import animationData from './lottie/logo.json';

interface ILottieLogoProps {
  height: string;
  width: string;
}

export default class LottieLogo extends React.Component<ILottieLogoProps> {
  render() {
    const { height, width } = this.props;
    const lottieHeight = height ? height : '40vw';
    const lottieWidth = width ? width : '40vw';

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    // @ts-ignore
    return (
      <Lottie
        options={defaultOptions}
        height={lottieHeight}
        width={lottieWidth}
      />
    );
  }
}
